import React from 'react'

// router
import { withRouter } from 'react-router-dom'

const ItemDetalleVenta = ({ item }) => {
    return (
        <tr>
            <th scope="row">{item.id}</th>
            <td>{item.medioPago.nombre}</td>
            <td>${item.monto.toFixed(2)}</td>
            <td>{item.createdAt.split('T')[0]}</td>
        </tr>
    )
}

export default withRouter(ItemDetalleVenta)
